/* Position heart button over the image top-right corner */
    function positionHeartBtn(btn) {
var slide = btn.closest('.product__media-item') || btn.parentElement;
var media = slide.querySelector('.product__media.media');
if (media && slide) {
var slideRect = slide.getBoundingClientRect();
var mediaRect = media.getBoundingClientRect();
var rightOffset = (slideRect.right - mediaRect.right) + 10;
btn.style.right = rightOffset + 'px';
btn.style.top = ((mediaRect.top - slideRect.top) + 10) + 'px';
      }
    }
/* ═══════════════════════════════════════════
   Logged-In Redirect  - Skip /account, go to homepage
   ═══════════════════════════════════════════ */
(function() {
var path = window.location.pathname;
var cid = window.__st && window.__st.cid;
// If user lands on /account (the default post-login page) and is logged in, redirect home
// Only redirect from the main /account page, not /account/login or /account/register etc.
if (cid && path !== '/account/logout' && (path === '/account' || path.match(/^\/\d+\/account\/?$/))) {
window.location.replace('/pages/my-rye-profile');
return;
  }
})();
// jQuery(document).ready(function(){
// //setTimeout(function() {
//       var appDiv = jQuery('.product-full-width .jm-review-widget-minimal-header__filter-container');
//       var appData = jQuery('.product-full-width .shopify-app-block').next().find('.collapsibles-wrapper:first .jm-review-widget-minimal-header');
//      jQuery(appDiv).appendTo(appData)
//      // debugger
//     // }, 15000);
//     });
//   })
/* =============================================
   Rye Profile - Favorites Heart Icon
   ============================================= */
(function() {
'use strict';
// Only run on product pages
if (!window.location.pathname.startsWith('/products/')) return;
var HEART_OUTLINE = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="heart-outline"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>';
var HEART_FILLED = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="heart-filled"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>';
function getProductId() {
if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
return String(window.ShopifyAnalytics.meta.product.id);
    }
var el = document.querySelector('[data-product-id]');
if (el) return el.getAttribute('data-product-id');
var jsonEl = document.querySelector('script[type="application/json"][data-product-json]');
if (jsonEl) { try { return String(JSON.parse(jsonEl.textContent).id); } catch(e) {} }
var form = document.querySelector('form[action*="/cart/add"]');
if (form) {
var input = form.querySelector('input[name="product-id"], input[name="id"]');
if (input) return input.value;
    }
return null;
  }
function createHeartButton() {
var btn = document.createElement('button');
btn.className = 'rye-heart-btn';
btn.type = 'button';
btn.setAttribute('aria-label', 'Add to favorites');
btn.innerHTML = HEART_OUTLINE + HEART_FILLED;
return btn;
  }
function checkStatus(productId, btn) {
fetch('/apps/rye-profile/api/favorites/status?product_id=' + productId, {
credentials: 'same-origin'
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
if (data.is_favorited) {
btn.classList.add('is-favorited');
btn.setAttribute('aria-label', 'Remove from favorites');
      }
    })
    .catch(function(err) { console.log('Rye Profile: status check error', err); });
  }
function toggleFavorite(productId, btn) {
if (btn.classList.contains('is-loading')) return;
btn.classList.add('is-loading');
var action = btn.classList.contains('is-favorited') ? 'remove' : 'add';
fetch('/apps/rye-profile/api/favorites', {
method: 'POST',
credentials: 'same-origin',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({ product_id: productId, action: action })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
btn.classList.remove('is-loading');
if (data.success || data.favorites) {
btn.classList.toggle('is-favorited');
btn.setAttribute('aria-label', btn.classList.contains('is-favorited') ? 'Remove from favorites' : 'Add to favorites');
      } else if (data.error && data.error.indexOf('log in') > -1) {
window.location.href = '/account/login?return_url=' + encodeURIComponent(window.location.pathname);
      }
    })
    .catch(function(err) {
btn.classList.remove('is-loading');
console.error('Rye Profile: toggle error', err);
    });
  }
function init() {
var productId = getProductId();
if (!productId) { console.log('Rye Profile: No product ID found'); return; }
// Target the main media wrapper - this is the outer container for the product gallery
var target = document.querySelector('.product__media-wrapper .product__media-item:first-child') || document.querySelector('.product__media-wrapper');
if (!target) { console.log('Rye Profile: No media wrapper found'); return; }
// Ensure relative positioning
if (window.getComputedStyle(target).position === 'static') {
target.style.position = 'relative';
    }
var heartBtn = createHeartButton();
target.appendChild(heartBtn);
positionHeartBtn(heartBtn);
window.addEventListener("resize", function() { positionHeartBtn(heartBtn); });
/* Also inject heart into mobile media (inside first slide) */
var mobileSlide = document.querySelector('.product__media-wrapper__mobile .slider__slide');
if (mobileSlide && !mobileSlide.querySelector('.rye-heart-btn')) {
var mobileHeartBtn = createHeartButton();
mobileHeartBtn.style.zIndex = '50';
mobileHeartBtn.style.touchAction = 'manipulation';
mobileHeartBtn.addEventListener('touchstart', function(e) {
e.stopPropagation();
          }, {passive: true});
mobileHeartBtn.addEventListener('touchend', function(e) {
e.stopPropagation();
          });
mobileHeartBtn.addEventListener('click', function(e) {
e.stopPropagation();
toggleFavorite(productId, mobileHeartBtn);
var desktopBtn = document.querySelector('.product__media-wrapper:not(.product__media-wrapper__mobile) .rye-heart-btn');
if (desktopBtn) {
desktopBtn.classList.toggle('is-favorited', mobileHeartBtn.classList.contains('is-favorited'));
            }
          });
mobileSlide.appendChild(mobileHeartBtn);
checkStatus(productId, mobileHeartBtn);
positionHeartBtn(mobileHeartBtn);
window.addEventListener('resize', function() { positionHeartBtn(mobileHeartBtn); });
        }
checkStatus(productId, heartBtn);
heartBtn.addEventListener('touchstart', function(e) { e.stopPropagation(); }, {passive: false});
heartBtn.addEventListener('click', function(e) {
e.stopPropagation();
e.preventDefault();
e.preventDefault();
e.stopPropagation();
toggleFavorite(productId, heartBtn);
    });
console.log('Rye Profile: Heart icon initialized for product ' + productId);
  }
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', function() { setTimeout(init, 500); });
  } else {
setTimeout(init, 500);
  }
})();
/* End Rye Profile Heart Icon */
/* =============================================
   My Favorites Page  - Load & Render Grid
   ============================================= */
(function() {
var grid = document.getElementById('favorites-grid');
if (!grid) return;
fetch('/apps/rye-profile/api/favorites/list')
    .then(function(r) { return r.json(); })
    .then(function(data) {
if (!data.products || data.products.length === 0) {
grid.innerHTML = '<div style="text-align:center;padding:60px 20px;">' +
'<svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="1.5"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
'<h3 style="color:#666;margin:20px 0 10px;">No favorites yet</h3>' +
'<p style="color:#999;margin-bottom:20px;">Click the heart icon on any product page to save it here.</p>' +
'<a href="/collections/all" style="display:inline-block;padding:12px 28px;background:#e8860c;color:#fff;text-decoration:none;border-radius:6px;font-weight:600;">Browse Products</a>' +
'</div>';
return;
      }
var html = '';
data.products.forEach(function(p) {
var price = p.price ? '$' + parseFloat(p.price).toFixed(2) : '';
html += '<div style="border:1px solid #eee;border-radius:8px;overflow:hidden;transition:box-shadow 0.2s;">' +
'<a href="' + p.url + '" style="text-decoration:none;color:inherit;">' +
          (p.image ? '<img src="' + p.image + '&width=400" alt="' + (p.imageAlt || p.title).replace(/"/g, '') + '" style="width:100%;aspect-ratio:1;object-fit:cover;">' : '<div style="width:100%;aspect-ratio:1;background:#f5f5f5;display:flex;align-items:center;justify-content:center;color:#ccc;">No image</div>') +
'<div style="padding:16px;">' +
'<h3 style="margin:0 0 8px;font-size:15px;line-height:1.3;">' + p.title + '</h3>' +
          (price ? '<p style="margin:0;color:#e8860c;font-weight:600;">' + price + '</p>' : '') +
'</div></a></div>';
      });
grid.innerHTML = html;
    })
    .catch(function(err) {
console.error('Favorites load error:', err);
grid.innerHTML = '<p style="color:#999;text-align:center;padding:40px;">Please <a href="/account/login">log in</a> to view your favorites.</p>';
    });
})();
/* End My Favorites Page */
/* ================================================
    Account Icon  – Dropdown Menu (All Users)
    ================================================ */
(function() {
// Detect logged-in state via Shopify analytics object
var cid = window.__st && window.__st.cid;
var isLoggedIn = !!cid;
var accountIcon = document.querySelector('.header__icon--account');
if (!accountIcon) return;
// 1. Add orange dot indicator to show logged-in state (only if logged in)
if (isLoggedIn) {
accountIcon.style.position = 'relative';
var dot = document.createElement('span');
dot.style.cssText = 'position:absolute;top:4px;right:4px;width:8px;height:8px;background:#e8860c;border-radius:50%;border:1.5px solid #000;';
accountIcon.appendChild(dot);
// 2. Change SVG fill to solid orange when logged in
var svg = accountIcon.querySelector('svg.icon-account');
if (svg) {
var paths = svg.querySelectorAll('path');
paths.forEach(function(p) { p.setAttribute('fill', '#e8860c'); });
    }
  }
// 3. Replace default link with dropdown
/* RC 21 Oct 2026: href kept so the link stays crawlable; the click handler below calls preventDefault */
accountIcon.style.cursor = 'pointer';
// Helper: open login in a centered popup window
function openLoginPopup() {
window.location.href = '/customer_authentication/login?return_to=/pages/my-hub';
  }
// Build dropdown menu
var dropdown = document.createElement('div');
dropdown.id = 'rc-account-dropdown';
dropdown.style.cssText = 'display:none;position:absolute;top:100%;right:0;background:#1a1a1a;border:1px solid #333;border-radius:8px;min-width:200px;box-shadow:0 4px 12px rgba(0,0,0,0.3);z-index:9999;padding:8px 0;';
// Build menu items — logged-in users see real links, logged-out users get popup login
var menuItems = isLoggedIn ? [
    { label: 'My Rye Profile', icon: '\u{1F943}', href: '/pages/my-rye-profile' },
    { label: 'My Lab Points', icon: '\u{1F3C5}', href: '/pages/lab-profile' },
    { label: 'Lab Leaderboard', icon: '\u{1F3C6}', href: '/pages/lab-leaderboard', pill: 'NEW' },
    { label: 'My Rye Matches', icon: '\u{1F3AF}', href: '/pages/my-rye-matches' },
    { label: 'My Favorites', icon: '❤', href: '/pages/my-favorites' },
    { label: 'My Orders', icon: '\u{1F4E6}', href: '/account' },
    { label: 'My Tasting Events', icon: '\u{1F943}', href: '/pages/my-tasting-events' },
    { divider: true },
    { label: 'Log Out', icon: '\u{1F6AA}', href: '/account/logout' }
  ] : [
    { label: 'My Rye Profile', icon: '\u{1F943}', href: '#', popup: true },
    { label: 'My Lab Points', icon: '\u{1F3C5}', href: '#', popup: true },
    { label: 'Lab Leaderboard', icon: '\u{1F3C6}', href: '/pages/lab-leaderboard', pill: 'NEW' },
    { label: 'My Rye Matches', icon: '\u{1F3AF}', href: '#', popup: true },
    { label: 'My Favorites', icon: '❤', href: '#', popup: true },
    { label: 'My Orders', icon: '\u{1F4E6}', href: '#', popup: true },
    { label: 'My Tasting Events', icon: '\u{1F943}', href: '#', popup: true },
    { divider: true },
    { label: 'Log In', icon: '\u{1F6AA}', href: '#', popup: true }
  ];
menuItems.forEach(function(item) {
if (item.divider) {
var hr = document.createElement('div');
hr.style.cssText = 'height:1px;background:#333;margin:6px 0;';
dropdown.appendChild(hr);
return;
    }
var a = document.createElement('a');
a.href = item.href;
a.style.cssText = 'display:flex;align-items:center;gap:10px;padding:10px 16px;color:#fff;text-decoration:none;font-size:14px;font-weight:500;transition:background 0.2s;';
a.innerHTML = '<span style="font-size:16px;">' + item.icon + '</span> ' + item.label + (item.pill ? ' <span style="background:#c62828;color:#fff;font-size:10px;font-weight:800;padding:2px 7px;border-radius:999px;letter-spacing:.06em;vertical-align:middle;">' + item.pill + '</span>' : '');
a.addEventListener('mouseenter', function() { this.style.background = '#2a2a2a'; });
a.addEventListener('mouseleave', function() { this.style.background = 'transparent'; });
// For logged-out users, open login popup instead of navigating
if (item.popup) {
a.addEventListener('click', function(e) {
e.preventDefault();
openLoginPopup();
      });
    }
dropdown.appendChild(a);
  });
// Wrap icon in a relative container for positioning
var wrapper = document.createElement('div');
wrapper.style.cssText = 'position:relative;display:inline-flex;align-items:center;';
accountIcon.parentNode.insertBefore(wrapper, accountIcon);
wrapper.appendChild(accountIcon);
wrapper.appendChild(dropdown);
// Logged-out visitors get an explicit "Join Free" label next to the icon —
// join and log-in are the same passwordless flow, so one label covers both.
if (!isLoggedIn) {
  if (!document.getElementById('rc-join-lbl-css')) {
    var jlCss = document.createElement('style');
    jlCss.id = 'rc-join-lbl-css';
    jlCss.textContent = '.rc-join-lbl{background:none;border:1.5px solid #d9ab52;color:#d9ab52;font-weight:700;font-size:12px;letter-spacing:.05em;padding:4px 11px;border-radius:999px;margin-right:9px;cursor:pointer;white-space:nowrap;font-family:inherit;line-height:1;transition:background .15s,color .15s}.rc-join-lbl:hover{background:#d9ab52;color:#241a0d}.rc-jl-short{display:none}@media(max-width:749px){.rc-join-lbl{font-size:11px;padding:4px 9px;margin-right:5px}.rc-jl-full{display:none}.rc-jl-short{display:inline}}';
    document.head.appendChild(jlCss);
  }
  var joinLbl = document.createElement('button');
  joinLbl.type = 'button';
  joinLbl.className = 'rc-join-lbl';
  joinLbl.innerHTML = '<span class="rc-jl-full">Join Free</span><span class="rc-jl-short">Join</span>';
  joinLbl.title = 'Join RyeCentral free — or log in';
  joinLbl.setAttribute('aria-label', 'Join RyeCentral free or log in');
  joinLbl.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openLoginPopup(); });
  wrapper.insertBefore(joinLbl, accountIcon);
}
// Toggle dropdown on click
var isOpen = false;
accountIcon.addEventListener('click', function(e) {
e.preventDefault();
e.stopPropagation();
isOpen = !isOpen;
dropdown.style.display = isOpen ? 'block' : 'none';
  });
// Close on click outside
document.addEventListener('click', function(e) {
if (!wrapper.contains(e.target)) {
isOpen = false;
dropdown.style.display = 'none';
    }
  });
})();
/* End Account Icon Dropdown */
/* ==========================================================
   My Rye Profile -- V2 Flavor Profile (card-based design)
   Matches the V2 review template design language
   ========================================================== */
(function() {
function initFlavorProfile() {
var wrap = document.getElementById('flavor-sliders');
if (!wrap) return;
if (wrap.getAttribute('data-rc-init')) return;
wrap.setAttribute('data-rc-init', '1');
var FLAVORS = [
      { key: 'sweetness',    label: 'Sweetness' },
      { key: 'ryeSpice',     label: 'Rye Spice' },
      { key: 'herbalMint',   label: 'Herbal / Mint' },
      { key: 'fruit',        label: 'Fruit' },
      { key: 'oakVanilla',   label: 'Oak / Vanilla' },
      { key: 'body',         label: 'Body' },
      { key: 'heat',         label: 'Heat' },
      { key: 'finishLength', label: 'Finish Length' }
    ];
var API = '/apps/rye-profile/api';
var cid = window.__st && window.__st.cid;
/* -- Inject page-level styles (once) -- */
if (!document.getElementById('rc-flavor-styles')) {
var style = document.createElement('style');
style.id = 'rc-flavor-styles';
style.textContent = [
/* Card container */
'.rc-card{border:1px solid #e5e5e0;border-radius:10px;padding:28px 32px;background:#fff;margin-bottom:20px}',
'.rc-card h2{font-family:Inter,sans-serif;font-size:22px;font-weight:700;color:#1a1a1a;margin:0 0 6px}',
'.main-page-title{font-family:Inter,sans-serif !important;font-weight:800 !important;font-size:28px !important}',
'.rc-card .rc-subtitle{font-size:15px;color:#666;margin:0 0 24px;line-height:1.4}',
/* Greeting banner */
'.rc-greeting{display:flex;align-items:center;gap:12px;padding:14px 20px;background:#fef7ee;border:1px solid #f5dbb8;border-radius:8px;margin-bottom:24px}',
'.rc-greeting-avatar{width:40px;height:40px;background:#e8912d;border-radius:50%;display:flex;align-items:center;justify-content:center;color:#fff;font-weight:700;font-size:18px;flex-shrink:0}',
'.rc-greeting-text{font-size:15px;color:#1a1a1a;font-weight:500}',
/* Flavor rows grid */
'.rc-flavor-row{display:grid;grid-template-columns:130px 1fr 36px;align-items:center;gap:14px;margin-bottom:14px}',
'.rc-flavor-label{font-size:15px;font-weight:600;color:#1a1a1a;white-space:nowrap}',
'.rc-flavor-value{font-size:15px;font-weight:700;color:#1a1a1a;text-align:right}',
/* Slider track */
'.rc-slider-wrap{position:relative;height:10px;background:#eee;border-radius:5px;cursor:pointer}',
'.rc-slider-fill{display:block !important;position:absolute;left:0;top:0;height:100%;background:#e8912d;border-radius:5px;transition:width .15s ease}',
'.rc-slider-thumb{display:block !important;position:absolute;top:50%;width:22px;height:22px;background:#e8912d;border:3px solid #fff;border-radius:50%;box-shadow:0 1px 4px rgba(0,0,0,.25);transform:translate(-50%,-50%);cursor:grab;transition:left .15s ease;z-index:2}',
'.rc-slider-thumb:hover{transform:translate(-50%,-50%) scale(1.15)}',
'.rc-slider-thumb:active{cursor:grabbing;box-shadow:0 0 0 4px rgba(232,145,45,.25)}',
/* Save button */
'.rc-save-btn{display:block;width:100%;padding:14px;background:#e8912d;color:#fff;border:none;border-radius:8px;font-size:16px;font-weight:600;cursor:pointer;margin-top:8px;transition:background .2s}',
'.rc-save-btn:hover{background:#d17f22}',
'.rc-save-btn:active{background:#b86e1a}',
/* Status message */
'.rc-status{text-align:center;margin-top:10px;font-size:14px;min-height:20px}',
'.rc-status.ok{color:#2e7d32}',
'.rc-status.err{color:#c62828}',
/* Quick Links */
'.rc-links{display:flex;gap:12px;flex-wrap:wrap;margin-top:8px}',
'.rc-link-btn{display:inline-flex;align-items:center;gap:8px;padding:10px 20px;background:#1a1a1a;color:#fff;text-decoration:none;border-radius:8px;font-size:14px;font-weight:600;transition:background .2s}',
'.rc-link-btn:hover{background:#333;color:#fff}',
/* Not logged in state */
'.rc-login-prompt{text-align:center;padding:40px 20px}',
'.rc-login-prompt p{font-size:16px;color:#666;margin:0 0 16px}',
'.rc-login-btn{display:inline-block;padding:12px 32px;background:#e8912d;color:#fff;text-decoration:none;border-radius:8px;font-size:16px;font-weight:600;transition:background .2s}',
'.rc-login-btn:hover{background:#d17f22;color:#fff}',
/* Responsive */
'@media(max-width:600px){.rc-flavor-row{grid-template-columns:100px 1fr 30px;gap:10px}.rc-card{padding:20px 16px}}'
      ].join('\n');
document.head.appendChild(style);
    }
/* -- Build the UI -- */
wrap.innerHTML = '';
if (!cid) {
/* Not logged in */
var card = document.createElement('div');
card.className = 'rc-card';
card.innerHTML = '<h2>My Flavor Preferences</h2>'
+ '<div class="rc-login-prompt">'
+ '<p>Sign in to set your personal rye whiskey flavor preferences and get tailored recommendations.</p>'
+ '<a href="/account/login" class="rc-login-btn">Sign In</a>'
+ '</div>';
wrap.appendChild(card);
return;
    }
/* -- Main card -- */
var card = document.createElement('div');
card.className = 'rc-card';
wrap.appendChild(card);
/* Heading */
var h2 = document.createElement('h2');
h2.textContent = 'My Flavor Preferences';
card.appendChild(h2);
var sub = document.createElement('p');
sub.className = 'rc-subtitle';
sub.textContent = 'Tell us what you like and we\'ll help you find the perfect bottle.';
card.appendChild(sub);
/* Greeting */
var greeting = document.createElement('div');
greeting.className = 'rc-greeting';
greeting.innerHTML = '<div class="rc-greeting-avatar">?</div><div class="rc-greeting-text">Loading...</div>';
card.appendChild(greeting);
/* Flavor rows */
var sliders = {};
var rowsWrap = document.createElement('div');
rowsWrap.style.marginTop = '20px';
card.appendChild(rowsWrap);
FLAVORS.forEach(function(f) {
var row = document.createElement('div');
row.className = 'rc-flavor-row';
var label = document.createElement('div');
label.className = 'rc-flavor-label';
label.textContent = f.label;
var sliderWrap = document.createElement('div');
sliderWrap.className = 'rc-slider-wrap';
var fill = document.createElement('div');
fill.className = 'rc-slider-fill';
var thumb = document.createElement('div');
thumb.className = 'rc-slider-thumb';
sliderWrap.appendChild(fill);
sliderWrap.appendChild(thumb);
var valEl = document.createElement('div');
valEl.className = 'rc-flavor-value';
valEl.textContent = '5';
row.appendChild(label);
row.appendChild(sliderWrap);
row.appendChild(valEl);
rowsWrap.appendChild(row);
sliders[f.key] = { wrap: sliderWrap, fill: fill, thumb: thumb, valEl: valEl, val: 5 };
    });
/* Save button */
var saveBtn = document.createElement('button');
saveBtn.className = 'rc-save-btn';
saveBtn.textContent = 'Save My Flavor Profile';
card.appendChild(saveBtn);
var status = document.createElement('div');
status.className = 'rc-status';
card.appendChild(status);
/* -- Quick Links card -- */
var linksCard = document.createElement('div');
linksCard.className = 'rc-card';
linksCard.innerHTML = '<h2>Quick Links</h2>'
+ '<div class="rc-links">'
+ '<a href="/pages/my-rye-matches" class="rc-link-btn">🎯 My Rye Matches</a>'
+ '<a href="/pages/my-favorites" class="rc-link-btn">❤️ My Favorites</a>'
+ '<a href="/account" class="rc-link-btn">📦 My Orders</a>'
+ '</div>';
wrap.appendChild(linksCard);
/* -- Slider interaction -- */
function setSlider(key, val) {
val = Math.max(1, Math.min(10, Math.round(val)));
var s = sliders[key];
s.val = val;
var pct = ((val - 1) / 9) * 100;
s.fill.style.width = pct + '%';
s.thumb.style.left = pct + '%';
s.valEl.textContent = val;
    }
function handleDrag(key, e) {
var s = sliders[key];
var rect = s.wrap.getBoundingClientRect();
var clientX = e.touches ? e.touches[0].clientX : e.clientX;
var pct = (clientX - rect.left) / rect.width;
var val = Math.round(pct * 9) + 1;
setSlider(key, val);
    }
Object.keys(sliders).forEach(function(key) {
var s = sliders[key];
function onStart(e) {
e.preventDefault();
handleDrag(key, e);
function onMove(ev) { handleDrag(key, ev); }
function onEnd() {
document.removeEventListener('mousemove', onMove);
document.removeEventListener('mouseup', onEnd);
document.removeEventListener('touchmove', onMove);
document.removeEventListener('touchend', onEnd);
        }
document.addEventListener('mousemove', onMove);
document.addEventListener('mouseup', onEnd);
document.addEventListener('touchmove', onMove, { passive: false });
document.addEventListener('touchend', onEnd);
      }
s.wrap.addEventListener('mousedown', onStart);
s.wrap.addEventListener('touchstart', onStart, { passive: false });
s.thumb.addEventListener('mousedown', onStart);
s.thumb.addEventListener('touchstart', onStart, { passive: false });
    });
/* Initialize sliders */
FLAVORS.forEach(function(f) { setSlider(f.key, 5); });
/* -- Load existing profile -- */
fetch(API + '/flavor-profile', { credentials: 'same-origin' })
      .then(function(r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function(d) {
if (d.firstName) {
greeting.innerHTML = '<div class="rc-greeting-avatar">' + d.firstName.charAt(0).toUpperCase() + '</div>'
+ '<div class="rc-greeting-text">Hey ' + d.firstName + '! Adjust the sliders to match your palate.</div>';
        }
if (d.profile) {
FLAVORS.forEach(function(f) {
if (d.profile[f.key]) setSlider(f.key, d.profile[f.key]);
          });
        }
      })
      .catch(function() {
greeting.innerHTML = '<div class="rc-greeting-avatar">!</div>'
+ '<div class="rc-greeting-text">Welcome! Set your flavor preferences below.</div>';
      });
/* -- Save -- */
saveBtn.addEventListener('click', function() {
saveBtn.disabled = true;
saveBtn.textContent = 'Saving...';
status.className = 'rc-status';
status.textContent = '';
var body = {};
FLAVORS.forEach(function(f) { body[f.key] = sliders[f.key].val; });
fetch(API + '/flavor-profile', {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
credentials: 'same-origin',
body: JSON.stringify(body)
      })
      .then(function(r) { return r.json().then(function(d) { return { ok: r.ok, data: d }; }); })
      .then(function(res) {
if (res.ok) {
status.className = 'rc-status ok';
status.textContent = 'Profile saved!';
        } else {
status.className = 'rc-status err';
status.textContent = 'Error: ' + (res.data.error || 'Save failed');
        }
      })
      .catch(function() {
status.className = 'rc-status err';
status.textContent = 'Network error - please try again.';
      })
      .finally(function() {
saveBtn.disabled = false;
saveBtn.textContent = 'Save My Flavor Profile';
      });
    });
  }
/* Run on load */
initFlavorProfile();
/* Re-run on bfcache restore */
window.addEventListener('pageshow', function(e) {
if (e.persisted) {
var wrap = document.getElementById('flavor-sliders');
if (wrap) { wrap.removeAttribute('data-rc-init'); }
initFlavorProfile();
    }
  });
})();
/* ==========================================================
   My Rye Matches -- shows bottles matching user preferences
   ========================================================== */
(function() {
function initRyeMatches() {
var wrap = document.getElementById('rye-matches-page');
if (!wrap) return;
if (wrap.getAttribute('data-rm-init')) return;
wrap.setAttribute('data-rm-init', '1');
var API = '/apps/rye-profile/api';
var cid = window.__st && window.__st.cid;
var KEYS = ['sweetness','ryeSpice','herbalMint','fruit','oakVanilla','body','heat','finishLength'];
var KEY_LABELS = {sweetness:'Sweetness',ryeSpice:'Rye Spice',herbalMint:'Herbal/Mint',fruit:'Fruit',oakVanilla:'Oak/Vanilla',body:'Body',heat:'Heat',finishLength:'Finish Length'};
/* -- Styles (once) -- */
if (!document.getElementById('rm-match-styles')) {
var style = document.createElement('style');
style.id = 'rm-match-styles';
style.textContent = [
'.rm-card{border:1px solid #e5e5e0;border-radius:10px;padding:28px 32px;background:#fff;margin-bottom:20px}',
'.rm-card h2{font-family:Inter,sans-serif;font-size:22px;font-weight:700;color:#1a1a1a;margin:0 0 6px}',
'.rm-subtitle{font-size:15px;color:#666;margin:0 0 24px;line-height:1.4}',
'.rm-login-prompt{text-align:center;padding:40px 20px}',
'.rm-login-prompt p{font-size:16px;color:#666;margin:0 0 16px}',
'.rm-login-btn{display:inline-block;padding:12px 32px;background:#e8912d;color:#fff;text-decoration:none;border-radius:8px;font-size:16px;font-weight:600;transition:background .2s}',
'.rm-login-btn:hover{background:#d17f22;color:#fff}',
'.rm-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:20px;margin-top:20px}',
'@media(max-width:900px){.rm-grid{grid-template-columns:repeat(2,1fr)}}',
'@media(max-width:560px){.rm-grid{grid-template-columns:1fr}}',
'.rm-product{border:1px solid #e5e5e0;border-radius:10px;overflow:hidden;background:#fff;transition:box-shadow .2s}',
'.rm-product:hover{box-shadow:0 4px 16px rgba(0,0,0,.08)}',
'.rm-product a{text-decoration:none;color:inherit;display:block}',
'.rm-product-img{width:100%;aspect-ratio:1/1;object-fit:cover;display:block;background:#f5f5f0}',
'.rm-product-info{padding:16px}',
'.rm-product-title{font-family:Inter,sans-serif;font-size:15px;font-weight:700;color:#1a1a1a;margin:0 0 6px;line-height:1.3}',
'.rm-product-price{font-size:14px;color:#666;margin:0 0 10px}',
'.rm-badge{display:inline-block;padding:4px 12px;border-radius:20px;font-size:13px;font-weight:700;color:#fff}',
'.rm-badge.perfect{background:#2e7d32}',
'.rm-badge.great{background:#e8912d}',
'.rm-badge.good{background:#666}',
'.rm-flavor-bars{margin-top:10px}',
'.rm-bar-row{display:flex;align-items:center;gap:8px;margin-bottom:4px}',
'.rm-bar-label{font-size:11px;color:#999;width:70px;text-align:right;flex-shrink:0}',
'.rm-bar-track{flex:1;height:4px;background:#eee;border-radius:2px;position:relative}',
'.rm-bar-fill{display:block !important;height:100%;border-radius:2px;position:absolute;left:0;top:0}',
'.rm-bar-fill.match{background:#2e7d32}',
'.rm-bar-fill.close{background:#e8912d}',
'.rm-bar-fill.off{background:#c62828}',
'.rm-empty{text-align:center;padding:40px 20px;color:#666;font-size:16px}',
'.rm-empty p{margin:0 0 12px}',
'.rm-section-label{font-family:Inter,sans-serif;font-size:16px;font-weight:700;color:#1a1a1a;margin:28px 0 12px;padding-bottom:8px;border-bottom:1px solid #e5e5e0}',
'.rm-loading{text-align:center;padding:40px;color:#666;font-size:16px}',
'.rm-back-link{display:inline-flex;align-items:center;gap:6px;font-size:14px;color:#e8912d;text-decoration:none;font-weight:600;margin-bottom:16px}',
'.rm-back-link:hover{color:#d17f22}'
      ].join('\n');
document.head.appendChild(style);
    }
wrap.innerHTML = '';
/* Not logged in */
if (!cid) {
var card = document.createElement('div');
card.className = 'rm-card';
card.innerHTML = '<h2>My Rye Matches</h2>'
+ '<div class="rm-login-prompt">'
+ '<p>Sign in to see which rye whiskeys match your flavor preferences.</p>'
+ '<a href="/account/login" class="rm-login-btn">Sign In</a>'
+ '</div>';
wrap.appendChild(card);
return;
    }
/* Main card */
var card = document.createElement('div');
card.className = 'rm-card';
card.innerHTML = '<a href="/pages/my-rye-profile" class="rm-back-link">← Back to My Rye Profile</a>'
+ '<h2>My Rye Matches</h2>'
+ '<p class="rm-subtitle">Bottles that match your flavor preferences. Adjust your sliders on My Rye Profile to refine results.</p>'
+ '<div class="rm-loading">Loading your matches...</div>';
wrap.appendChild(card);
/* Fetch profile + catalog in parallel */
var catalogUrl = '/pages/rye-flavor-catalog';
Promise.all([
fetch(API + '/flavor-profile', { credentials: 'same-origin' }).then(function(r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); }),
fetch(catalogUrl).then(function(r) { return r.text(); }).then(function(t) { var s = t.trim(); return JSON.parse(s.substring(s.indexOf('['), s.lastIndexOf(']') + 1)); })
    ]).then(function(results) {
var profileData = results[0];
var catalog = results[1];
var loading = card.querySelector('.rm-loading');
if (loading) loading.remove();
if (!profileData.profile) {
card.innerHTML += '<div class="rm-empty"><p>You haven\'t set your flavor preferences yet.</p>'
+ '<a href="/pages/my-rye-profile" class="rm-login-btn">Set My Preferences</a></div>';
return;
      }
var userProfile = profileData.profile;
/* Score each product */
var scored = catalog.map(function(product) {
var totalDiff = 0;
var maxDiff = 0;
KEYS.forEach(function(key) {
var diff = Math.abs((product.flavors[key] || 5) - (userProfile[key] || 5));
totalDiff += diff;
if (diff > maxDiff) maxDiff = diff;
        });
var matchPct = Math.round((1 - totalDiff / 72) * 100);
return {
handle: product.handle,
title: product.title,
image: product.image,
price: product.price,
flavors: product.flavors,
totalDiff: totalDiff,
maxDiff: maxDiff,
matchPct: matchPct
        };
      });
/* Sort by match percentage descending */
scored.sort(function(a, b) { return b.matchPct - a.matchPct; });
/* Split into tiers */
var perfect = scored.filter(function(p) { return p.maxDiff <= 1; });
var great = scored.filter(function(p) { return p.maxDiff > 1 && p.matchPct >= 85; });
var good = scored.filter(function(p) { return p.maxDiff > 1 && p.matchPct >= 70 && p.matchPct < 85; });
function renderGrid(items, tierClass) {
var grid = document.createElement('div');
grid.className = 'rm-grid';
items.forEach(function(p) {
var el = document.createElement('div');
el.className = 'rm-product';
var badgeClass = p.matchPct >= 95 ? 'perfect' : (p.matchPct >= 85 ? 'great' : 'good');
var badgeText = p.matchPct >= 95 ? 'Perfect Match' : (p.matchPct >= 85 ? 'Great Match' : 'Good Match');
var imgHtml = p.image ? '<img class="rm-product-img" src="' + p.image + '" alt="' + p.title.replace(/"/g, '') + '" loading="lazy">' : '<div class="rm-product-img"></div>';
var barsHtml = '';
KEYS.forEach(function(key) {
var pv = p.flavors[key] || 5;
var uv = userProfile[key] || 5;
var diff = Math.abs(pv - uv);
var fillClass = diff === 0 ? 'match' : (diff <= 1 ? 'match' : (diff <= 2 ? 'close' : 'off'));
var pct = ((pv - 1) / 9) * 100;
barsHtml += '<div class="rm-bar-row"><div class="rm-bar-label">' + KEY_LABELS[key] + '</div><div class="rm-bar-track"><div class="rm-bar-fill ' + fillClass + '" style="width:' + pct + '%"></div></div></div>';
          });
var priceHtml = p.price ? '<p class="rm-product-price">$' + parseFloat(p.price).toFixed(2) + '</p>' : '';
el.innerHTML = '<a href="/products/' + p.handle + '">'
+ imgHtml
+ '<div class="rm-product-info">'
+ '<h3 class="rm-product-title">' + p.title.replace(' Review', '').replace(': An In-Depth Taste Test', '') + '</h3>'
+ priceHtml
+ '<span class="rm-badge ' + badgeClass + '">' + badgeText + ' ' + p.matchPct + '%</span>'
+ barsHtml
+ '</div></a>';
grid.appendChild(el);
        });
return grid;
      }
if (perfect.length === 0 && great.length === 0 && good.length === 0) {
card.innerHTML += '<div class="rm-empty"><p>No close matches found yet. Try adjusting your flavor preferences on My Rye Profile.</p>'
+ '<a href="/pages/my-rye-profile" class="rm-login-btn">Adjust Preferences</a></div>';
return;
      }
if (perfect.length > 0) {
var label = document.createElement('div');
label.className = 'rm-section-label';
label.textContent = '🎯 Perfect Matches (±1 on every attribute)';
card.appendChild(label);
card.appendChild(renderGrid(perfect, 'perfect'));
      }
if (great.length > 0) {
var label2 = document.createElement('div');
label2.className = 'rm-section-label';
label2.textContent = '🔥 Great Matches (85%+)';
card.appendChild(label2);
card.appendChild(renderGrid(great, 'great'));
      }
if (good.length > 0) {
var label3 = document.createElement('div');
label3.className = 'rm-section-label';
label3.textContent = '👍 Good Matches (70%+)';
card.appendChild(label3);
card.appendChild(renderGrid(good, 'good'));
      }
    }).catch(function(err) {
var loading = card.querySelector('.rm-loading');
if (loading) loading.textContent = 'Error loading matches. Please try again.';
console.error('Rye Matches error:', err);
    });
  }
/* Run on load */
initRyeMatches();
/* Re-run on bfcache restore */
window.addEventListener('pageshow', function(e) {
if (e.persisted) {
var wrap = document.getElementById('rye-matches-page');
if (wrap) { wrap.removeAttribute('data-rm-init'); }
initRyeMatches();
    }
  });
})();
/* ==========================================================
   RyeCentral Tasting Card PDF Generator  —  Blind-Tasting Edition
   Add this to the END of assets/custom.js
   Works on all V2 review pages with .rc-dl-card button
   LAYOUT (landscape A5):
   ┌─────────────────────┊─────────────────────┐
   │  YOUR TASTING NOTES  ┊  COMMUNITY REVEAL   │
   │  (blank lines to     ┊  (filled tasting     │
   │   write on)          ┊   notes + flavor     │
   │                      ┊   bars + score)      │
   │  YOUR FLAVOR RATINGS ┊                      │
   │  (empty bars to      ┊  FLAVOR PROFILE      │
   │   fill in 1-10)      ┊  (filled bars)       │
   └─────────────────────┊─────────────────────┘
   Fold in half → blind taste on left, reveal on right
   ========================================================== */
(function() {
var btn = document.querySelector('.rc-dl-card');
if (!btn) return;
btn.addEventListener('click', function() {
if (typeof window.jspdf === 'undefined') {
/* RC perf: load jsPDF on demand (first click), then re-run the handler */
if (btn.dataset.rcPdfLoading) return;
btn.dataset.rcPdfLoading = '1';
var s = document.createElement('script');
s.src = 'https://unpkg.com/jspdf@2.5.2/dist/jspdf.umd.min.js';
s.onload = function() { delete btn.dataset.rcPdfLoading; btn.click(); };
s.onerror = function() { delete btn.dataset.rcPdfLoading; alert('Could not load the PDF generator. Please check your connection and try again.'); };
document.head.appendChild(s);
return;
    }
var jsPDF = window.jspdf.jsPDF;
var doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a5' });
var W = doc.internal.pageSize.getWidth();   /* ~210mm */
var H = doc.internal.pageSize.getHeight();  /* ~148mm */
var MID = W / 2;
var ORANGE = [232, 134, 12];
var DARK = [26, 26, 26];
var GRAY = [107, 107, 101];
var LIGHT_BG = [248, 248, 245];
var LINE_COLOR = [200, 200, 195];
/* ── helpers ── */
function getText(sel) {
var el = document.querySelector(sel);
return el ? el.textContent.trim() : '';
    }
function drawWriteLine(x, y, w) {
doc.setDrawColor(LINE_COLOR[0], LINE_COLOR[1], LINE_COLOR[2]);
doc.setLineWidth(0.3);
doc.line(x, y, x + w, y);
    }
/* ── extract data from the live page ── */
var title = document.querySelector('.product__title h1');
var productName = title ? title.textContent.trim() : 'Rye Whiskey';
/* Tasting notes */
var tastingCards = document.querySelectorAll('.rc-tasting-card');
var nose = '', palate = '', finish = '';
tastingCards.forEach(function(card) {
var label = card.querySelector('h4');
var text = card.querySelector('p');
if (!label || !text) return;
var l = label.textContent.trim().toUpperCase();
if (l === 'NOSE') nose = text.textContent.trim();
if (l === 'PALATE') palate = text.textContent.trim();
if (l === 'FINISH') finish = text.textContent.trim();
    });
/* Flavor profile */
var flavorRows = document.querySelectorAll('.rc-flavor-row');
var flavors = [];
flavorRows.forEach(function(row) {
var label = row.querySelector('.rc-flavor-label');
var val = row.querySelector('.rc-flavor-val');
if (label && val) {
flavors.push({ name: label.textContent.trim(), score: parseInt(val.textContent.trim()) || 0 });
      }
    });
/* Community score */
var commScore = getText('.rc-comm-big-score') || '—';
var commCount = getText('.rc-comm-count') || '';
/* Quick facts */
var facts = {};
document.querySelectorAll('.rc-fact-item').forEach(function(item) {
var lbl = item.querySelector('.rc-fact-label');
var val = item.querySelector('.rc-fact-value');
if (lbl && val) facts[lbl.textContent.trim().toUpperCase()] = val.textContent.trim();
    });
/* ════════════════════════════════════════
       COMPACT HEADER — thin orange bar + name/facts on one line
       ════════════════════════════════════════ */
doc.setFillColor(ORANGE[0], ORANGE[1], ORANGE[2]);
doc.rect(0, 0, W, 8, 'F');
doc.setFont('helvetica', 'bold');
doc.setFontSize(8);
doc.setTextColor(255, 255, 255);
doc.text('RYECENTRAL TASTING CARD', 8, 5.5);
doc.setFontSize(6.5);
doc.setFont('helvetica', 'normal');
doc.text('ryecentral.com', W - 8, 5.5, { align: 'right' });
/* Product name + facts in compact block */
doc.setTextColor(DARK[0], DARK[1], DARK[2]);
doc.setFont('helvetica', 'bold');
doc.setFontSize(10);
var nameLines = doc.splitTextToSize(productName, W - 20);
doc.text(nameLines, W / 2, 14, { align: 'center' });
var yAfterName = 14 + (nameLines.length * 4.5);
/* Quick facts — same line, tight */
var factsLine = [];
if (facts['PROOF / ABV']) factsLine.push(facts['PROOF / ABV']);
if (facts['AGE']) factsLine.push(facts['AGE']);
if (facts['MASH BILL']) factsLine.push(facts['MASH BILL']);
if (factsLine.length > 0) {
doc.setFont('helvetica', 'normal');
doc.setFontSize(6.5);
doc.setTextColor(GRAY[0], GRAY[1], GRAY[2]);
doc.text(factsLine.join('  |  '), W / 2, yAfterName, { align: 'center' });
yAfterName += 4;
    }
/* ── Dashed fold line down the center ── */
doc.setDrawColor(ORANGE[0], ORANGE[1], ORANGE[2]);
doc.setLineWidth(0.4);
doc.setLineDashPattern([2, 2], 0);
doc.line(MID, yAfterName, MID, H - 6);
doc.setLineDashPattern([], 0); /* reset */
/* Fold instruction at bottom of fold line */
doc.setFont('helvetica', 'normal');
doc.setFontSize(5);
doc.setTextColor(GRAY[0], GRAY[1], GRAY[2]);
doc.text('← FOLD HERE →', MID, H - 7, { align: 'center' });
/* ════════════════════════════════════════
       LEFT HALF — BLIND TASTING (your notes)
       ════════════════════════════════════════ */
var LM = 8;                    /* left margin */
var LW = MID - LM - 6;        /* usable width */
var lY = yAfterName + 3;
/* Section header: YOUR TASTING NOTES */
doc.setFont('helvetica', 'bold');
doc.setFontSize(8);
doc.setTextColor(ORANGE[0], ORANGE[1], ORANGE[2]);
doc.text('YOUR TASTING NOTES', LM, lY);
lY += 5;
/* Nose / Palate / Finish — each with 3 blank lines */
var sections = ['Nose', 'Palate', 'Finish'];
sections.forEach(function(s) {
doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.setTextColor(DARK[0], DARK[1], DARK[2]);
doc.text(s + ':', LM, lY);
lY += 3.5;
/* 3 writing lines */
for (var i = 0; i < 3; i++) {
drawWriteLine(LM, lY, LW);
lY += 3.5;
      }
lY += 1;
    });
/* Section header: YOUR FLAVOR RATINGS */
lY += 1;
doc.setFont('helvetica', 'bold');
doc.setFontSize(8);
doc.setTextColor(ORANGE[0], ORANGE[1], ORANGE[2]);
doc.text('YOUR FLAVOR RATINGS', LM, lY);
doc.setFont('helvetica', 'normal');
doc.setFontSize(5.5);
doc.setTextColor(GRAY[0], GRAY[1], GRAY[2]);
doc.text('(rate 1–10)', LM + 42, lY);
lY += 5;
/* Empty flavor bars with labels — same flavors as community side */
var lBarX = LM + 28;
var lBarW = LW - 38;
flavors.forEach(function(f) {
doc.setFont('helvetica', 'normal');
doc.setFontSize(7);
doc.setTextColor(DARK[0], DARK[1], DARK[2]);
doc.text(f.name, LM, lY);
/* Empty track */
doc.setFillColor(LIGHT_BG[0], LIGHT_BG[1], LIGHT_BG[2]);
doc.roundedRect(lBarX, lY - 2.5, lBarW, 3.5, 1.5, 1.5, 'F');
/* Small "/ 10" label */
doc.setFont('helvetica', 'normal');
doc.setFontSize(5.5);
doc.setTextColor(GRAY[0], GRAY[1], GRAY[2]);
doc.text('/10', lBarX + lBarW + 2, lY);
lY += 5;
    });
/* YOUR SCORE box */
lY += 2;
doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.setTextColor(DARK[0], DARK[1], DARK[2]);
doc.text('YOUR OVERALL SCORE:', LM, lY);
doc.setDrawColor(LINE_COLOR[0], LINE_COLOR[1], LINE_COLOR[2]);
doc.setLineWidth(0.4);
doc.roundedRect(LM + 40, lY - 4, 20, 7, 2, 2, 'S');
doc.setFont('helvetica', 'normal');
doc.setFontSize(5.5);
doc.setTextColor(GRAY[0], GRAY[1], GRAY[2]);
doc.text('/5', LM + 61, lY);
/* ════════════════════════════════════════
       RIGHT HALF — COMMUNITY REVEAL
       ════════════════════════════════════════ */
var RM = MID + 6;              /* right margin start */
var RW = W - RM - 8;          /* usable width */
var rY = yAfterName + 3;
/* Section header */
doc.setFont('helvetica', 'bold');
doc.setFontSize(8);
doc.setTextColor(ORANGE[0], ORANGE[1], ORANGE[2]);
doc.text('COMMUNITY TASTING NOTES', RM, rY);
rY += 5;
/* Nose / Palate / Finish — filled with community text */
var noteData = [
      { label: 'Nose', text: nose },
      { label: 'Palate', text: palate },
      { label: 'Finish', text: finish }
    ];
noteData.forEach(function(note) {
doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.setTextColor(DARK[0], DARK[1], DARK[2]);
doc.text(note.label + ':', RM, rY);
rY += 3.5;
if (note.text) {
doc.setFont('helvetica', 'normal');
doc.setFontSize(6.5);
doc.setTextColor(GRAY[0], GRAY[1], GRAY[2]);
var wrapped = doc.splitTextToSize(note.text, RW);
var maxLines = Math.min(wrapped.length, 3);
for (var i = 0; i < maxLines; i++) {
doc.text(wrapped[i], RM, rY);
rY += 2.8;
        }
      }
rY += 2;
    });
/* Section header: COMMUNITY FLAVOR PROFILE */
rY += 1;
doc.setFont('helvetica', 'bold');
doc.setFontSize(8);
doc.setTextColor(ORANGE[0], ORANGE[1], ORANGE[2]);
doc.text('COMMUNITY FLAVOR PROFILE', RM, rY);
rY += 5;
/* Filled flavor bars */
var rBarX = RM + 28;
var rBarW = RW - 38;
flavors.forEach(function(f) {
doc.setFont('helvetica', 'normal');
doc.setFontSize(7);
doc.setTextColor(DARK[0], DARK[1], DARK[2]);
doc.text(f.name, RM, rY);
/* Track bg */
doc.setFillColor(LIGHT_BG[0], LIGHT_BG[1], LIGHT_BG[2]);
doc.roundedRect(rBarX, rY - 2.5, rBarW, 3.5, 1.5, 1.5, 'F');
/* Filled portion */
var fillW = (f.score / 10) * rBarW;
if (fillW > 0) {
doc.setFillColor(ORANGE[0], ORANGE[1], ORANGE[2]);
doc.roundedRect(rBarX, rY - 2.5, fillW, 3.5, 1.5, 1.5, 'F');
      }
/* Score number */
doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.setTextColor(ORANGE[0], ORANGE[1], ORANGE[2]);
doc.text('' + f.score, rBarX + rBarW + 2, rY);
rY += 5;
    });
/* Community score — compact inline */
rY += 2;
doc.setFont('helvetica', 'normal');
doc.setFontSize(6.5);
doc.setTextColor(GRAY[0], GRAY[1], GRAY[2]);
doc.text('Community Score:', RM, rY);
doc.setFont('helvetica', 'bold');
doc.setFontSize(9);
doc.setTextColor(ORANGE[0], ORANGE[1], ORANGE[2]);
doc.text(commScore + ' / 5', RM + 28, rY);
/* ── Footer ── */
doc.setFontSize(5);
doc.setTextColor(GRAY[0], GRAY[1], GRAY[2]);
doc.text('Generated from ryecentral.com — Print, fold in half, and blind taste!', W / 2, H - 2, { align: 'center' });
/* ── Save ── */
var filename = productName.replace(/[^a-zA-Z0-9]/g, '-').replace(/-+/g, '-').toLowerCase();
doc.save(filename + '-tasting-card.pdf');
  });
})();
/* ===== V2 Mobile Menu Fix: Reorganize "Rye Whiskey Reviews" submenu ===== */
(function() {
function v2MenuFix() {
var parentMenu = document.querySelector('#link-rye-whiskey-reviews .menu-drawer__menu');
if (!parentMenu || parentMenu.dataset.v2fixed) return;
parentMenu.dataset.v2fixed = '1';
/* 1. Create "All Reviews" link at top */
var allLi = document.createElement('li');
var allLink = document.createElement('a');
allLink.href = '/collections/rye-whiskey-reviews';
allLink.className = 'menu-drawer__menu-item link link--text list-menu__item focus-inset';
allLink.textContent = 'All Reviews';
allLi.appendChild(allLink);
parentMenu.insertBefore(allLi, parentMenu.children[0]);
/* 2. Find "All Reviews" accordion and flatten its children */
var allReviewsDetails = document.querySelector('#Details-menu-drawer-rye-whiskey-reviews-all-reviews');
if (allReviewsDetails) {
var allReviewsLi = allReviewsDetails.closest('li');
var childMenu = document.querySelector('#childlink-all-reviews .menu-drawer__menu');
if (childMenu) {
var flatItems = ['Latest Reviews', 'Editor\'s Picks', 'Community Top Rated'];
var top5Items = [];
Array.from(childMenu.children).forEach(function(li) {
var link = li.querySelector('a');
if (!link) return;
if (link.classList.contains('rc-menu-viewall')) return;
var text = link.textContent.trim();
if (text.indexOf('Top 5') === 0) {
top5Items.push(li);
          } else if (flatItems.indexOf(text) !== -1) {
parentMenu.insertBefore(li, allReviewsLi);
          }
        });
/* 3. Create "Top 5 Rye Whiskeys" expandable accordion */
if (top5Items.length > 0) {
var top5Li = document.createElement('li');
var top5Details = document.createElement('details');
top5Details.id = 'Details-menu-drawer-top5-rye';
var top5Summary = document.createElement('summary');
top5Summary.className = 'menu-drawer__menu-item link link--text list-menu__item focus-inset';
var sumSpan = document.createElement('span');
sumSpan.textContent = 'Top 5 Rye Whiskeys';
top5Summary.appendChild(sumSpan);
var caretSvg = allReviewsDetails.querySelector('summary .icon-caret');
if (caretSvg) top5Summary.appendChild(caretSvg.cloneNode(true));
top5Details.appendChild(top5Summary);
var panel = document.createElement('div');
panel.id = 'childlink-top5-rye';
panel.className = 'menu-drawer__submenu has-submenu gradient motion-reduce';
panel.style.cssText = 'z-index:9999999;position:absolute;top:0;left:0;right:0;bottom:0;overflow-y:auto;background:rgb(248,248,245);';
var backBtn = document.createElement('button');
backBtn.className = 'menu-drawer__close-button';
backBtn.setAttribute('aria-expanded', 'true');
backBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" class="icon icon-arrow" style="width:12px;height:12px;margin-right:6px;"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path></svg> Top 5 Rye Whiskeys';
backBtn.addEventListener('click', function() { top5Details.removeAttribute('open'); });
panel.appendChild(backBtn);
var top5Ul = document.createElement('ul');
top5Ul.className = 'menu-drawer__menu list-menu';
top5Ul.setAttribute('role', 'list');
top5Items.forEach(function(li) { top5Ul.appendChild(li); });
panel.appendChild(top5Ul);
top5Details.appendChild(panel);
top5Li.appendChild(top5Details);
parentMenu.insertBefore(top5Li, allReviewsLi);
        }
      }
/* 4. Hide the emptied "All Reviews" accordion */
if (allReviewsLi) allReviewsLi.style.display = 'none';
    }
  }
v2MenuFix();
var menuDrawer = document.querySelector('#menu-drawer');
if (menuDrawer) {
var observer = new MutationObserver(function() {
var parentMenu = document.querySelector('#link-rye-whiskey-reviews .menu-drawer__menu');
if (parentMenu && !parentMenu.dataset.v2fixed) v2MenuFix();
    });
observer.observe(menuDrawer, { attributes: true, subtree: true, attributeFilter: ['open'] });
  }
})();
/* ==========================================================
   Lab Tier Chips on Reviews (2026-07-20)
   Shows the rank a member held when they wrote a review, as a
   gold chip next to their name in the Judge.me widget. Data:
   lab-points-worker /review-tiers (public, same info as the
   leaderboard). Pre-feature reviews have no snapshot -> no chip.
   ========================================================== */
(function() {
  'use strict';
  var WORKER = 'https://lab-points-worker.silent-sky-6573.workers.dev';
  var tiers = null;

  function findProductId() {
    var sec = document.querySelector('.rc-judgeme-section[data-product-id]');
    if (sec) return sec.getAttribute('data-product-id');
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      return String(window.ShopifyAnalytics.meta.product.id);
    }
    return null;
  }

  function reviewIdOf(el) {
    if (el.dataset && el.dataset.reviewId) return el.dataset.reviewId;
    var cand = el.getAttribute('data-jdgm-review-id') || el.getAttribute('data-id');
    if (cand) return cand;
    var id = el.getAttribute('id') || '';
    var m = id.match(/(\d{6,})/);
    return m ? m[1] : null;
  }

  function injectCss() {
    if (document.getElementById('rc-tier-chip-css')) return;
    var s = document.createElement('style');
    s.id = 'rc-tier-chip-css';
    s.textContent = '.rc-tier-chip{display:inline-block;margin-left:8px;border:1.5px solid #d9ab52;color:#c9932e;font-weight:800;font-size:10px;letter-spacing:.09em;text-transform:uppercase;padding:2px 9px;border-radius:999px;vertical-align:middle;white-space:nowrap;font-family:Inter,Arial,sans-serif}';
    document.head.appendChild(s);
  }

  function sweep() {
    if (!tiers) return;
    document.querySelectorAll('.jdgm-rev').forEach(function(el) {
      if (el.dataset.rcTierDone) return;
      var rid = reviewIdOf(el);
      if (!rid || !tiers[rid]) return;
      var author = el.querySelector('.jdgm-rev__author');
      if (!author) return;
      el.dataset.rcTierDone = '1';
      var chip = document.createElement('span');
      chip.className = 'rc-tier-chip';
      chip.textContent = tiers[rid];
      author.appendChild(chip);
    });
  }

  function init() {
    var pid = findProductId();
    if (!pid) return;
    // Only bother on pages that can render reviews
    if (!document.querySelector('.rc-judgeme-section') && !/^\/products\//.test(window.location.pathname)) return;
    fetch(WORKER + '/review-tiers?product_id=' + encodeURIComponent(pid))
      .then(function(r) { return r.json(); })
      .then(function(d) {
        if (!d || !d.ok || !d.tiers || !Object.keys(d.tiers).length) return;
        tiers = d.tiers;
        injectCss();
        sweep();
        var n = 0;
        var iv = setInterval(function() { sweep(); if (++n > 15) clearInterval(iv); }, 1000);
        new MutationObserver(sweep).observe(document.body, { childList: true, subtree: true });
      })
      .catch(function() {});
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
/* End Lab Tier Chips */
